const basePath = '/care';
const LOCALE_COUNTRY = {
    'vi-VN': { id: 1, name: 'Vietnam' },
    'id-ID': { id: 2, name: 'Indonesia' },
    'ms-MY': { id: 3, name: 'Malaysia' },
    'km-KH': { id: 4, name: 'Cambodia' },
    'en-PH': { id: 5, name: 'Philippines' },
    'th-TH': { id: 6, name: 'Thai Lan' },
    'my-MM': { id: 7, name: 'Myanmar' },
    'zh-TW': { id: 8, name: 'Taiwan' },
    'hi-IN': { id: 9, name: 'India' },
    'zh-CN': { id: 11, name: 'China' },
};
const LOCALIZED_SLUGS = {
    'en-PH': {
        ALL: 'all',
        HOSPITAL: 'hospital',
        SERVICE: 'service',
        DOCTOR: 'doctor',
        SEARCH: 'search',
        SPECIALTIES: 'specialties',
        CURRENT: 'current-location',
    },
    'tl-PH': {
        ALL: 'all',
        HOSPITAL: 'hospital',
        SERVICE: 'service',
        DOCTOR: 'doctor',
        SEARCH: 'search',
        SPECIALTIES: 'specialties',
        CURRENT: 'current-location',
    },
    'zh-TW': {
        ALL: 'all',
        HOSPITAL: 'hospital',
        SERVICE: 'service',
        DOCTOR: 'doctor',
        SEARCH: 'search',
        SPECIALTIES: 'specialties',
        CURRENT: 'current-location',
    },
    'vi-VN': {
        ALL: 'tat-ca',
        HOSPITAL: 'benh-vien',
        SERVICE: 'dich-vu',
        DOCTOR: 'bac-si',
        SEARCH: 'tim-kiem',
        SPECIALTIES: 'chuyen-khoa',
        CURRENT: 'vi-tri-hien-tai',
    },
    'id-ID': {
        ALL: 'semua',
        HOSPITAL: 'rumah-sakit',
        SERVICE: 'layanan',
        DOCTOR: 'dokter',
        SEARCH: 'cari',
        SPECIALTIES: 'spesialisasi',
        CURRENT: 'posisi-saya-saat-ini',
    },
    'ms-MY': {
        ALL: 'all',
        HOSPITAL: 'hospital',
        SERVICE: 'service',
        DOCTOR: 'doctor',
        SEARCH: 'search',
        SPECIALTIES: 'specialties',
        CURRENT: 'current-location',
    },
};
const ID_OPTION_CURRENT_LOCATION = -1;
const ID_OPTION_ALL_LOCATION = -2;
var CLIENT_KEY;
(function (CLIENT_KEY) {
    CLIENT_KEY["GSK"] = "gsk";
    CLIENT_KEY["ROCHE"] = "roche";
    CLIENT_KEY["MSD"] = "msd";
})(CLIENT_KEY || (CLIENT_KEY = {}));
var SLUG_CLIENT_KEY;
(function (SLUG_CLIENT_KEY) {
    SLUG_CLIENT_KEY["GSK"] = "gsk";
    SLUG_CLIENT_KEY["ROCHE"] = "roche";
    SLUG_CLIENT_KEY["MSD"] = "spesialis";
})(SLUG_CLIENT_KEY || (SLUG_CLIENT_KEY = {}));
const SLUG_VACIN_ID = 'vaksin-rotavirus';
const MAPPING_CLIENT_WITH_SLUG = {
    'vi-VN': {
        gsk: SLUG_CLIENT_KEY.GSK,
        msd: SLUG_CLIENT_KEY.MSD,
    },
    'id-ID': {
        gsk: SLUG_CLIENT_KEY.GSK,
        msd: SLUG_CLIENT_KEY.MSD,
    },
    'en-PH': {},
    'zh-TW': {},
    'ms-MY': {},
    'tl-PH': {},
};

var constants = /*#__PURE__*/Object.freeze({
  __proto__: null,
  basePath: basePath,
  LOCALE_COUNTRY: LOCALE_COUNTRY,
  LOCALIZED_SLUGS: LOCALIZED_SLUGS,
  ID_OPTION_CURRENT_LOCATION: ID_OPTION_CURRENT_LOCATION,
  ID_OPTION_ALL_LOCATION: ID_OPTION_ALL_LOCATION,
  get CLIENT_KEY () { return CLIENT_KEY; },
  get SLUG_CLIENT_KEY () { return SLUG_CLIENT_KEY; },
  SLUG_VACIN_ID: SLUG_VACIN_ID,
  MAPPING_CLIENT_WITH_SLUG: MAPPING_CLIENT_WITH_SLUG
});

export { CLIENT_KEY as C, ID_OPTION_ALL_LOCATION as I, LOCALIZED_SLUGS as L, MAPPING_CLIENT_WITH_SLUG as M, SLUG_VACIN_ID as S, ID_OPTION_CURRENT_LOCATION as a, constants as c };
